import axios from "axios";
import { useState } from "react";
import { MdLogin } from "react-icons/md";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Spin from "../../Components/Spin";
import useForm from "../../hook/useForm";
import { setAuth } from "../../store/reducer/auth";
import { API_URL } from "../../Utils/constants";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);
  const iconLock = <span className="fas fa-eye-slash" />;
  const iconEye = <span className="fas fa-eye" />;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { values, handleChange, resetForm } = useForm({
    username: "",
    password: "",
  });

  document.body.classList.add("login-page");
  document.title = "DashBoard | Login";

  const login = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const { username, password } = values;

    if (username === "" || password === "") {
      toast.warning("Remplissez tous les champs!");
      return;
    }

    try {
      const response = await axios.post(API_URL + "login", {
        username,
        password,
      });

      if (!response) {
        toast.error("Identifiants incorrects");
        return;
      }

      const { data } = await axios.get(API_URL + `users/current`, {
        headers: {
          Authorization: `Bearer ${response.data.token}`,
        },
      });

      console.log(data);
      localStorage.setItem("token", btoa(response.data.token));
      localStorage.setItem("refresh_token", btoa(response.data.refresh_token));

      dispatch(setAuth(data));
      toast.success("Vous ètes connecté.");

      navigate("/");
    } catch (error) {
      if (error.response.status === 401) {
        toast.error("Vous ètes inactif. Contactez l'administrateur.");
        console.log(error);
      }
    } finally {
      resetForm();
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="login-box login-page"
        style={{ backgroundColor: "inherit" }}
      >
        {/* /.login-logo */}
        <div className="card card-outline card-primary">
          <div className="card-header text-center">
            <b>GAPIENA</b>
          </div>
          <div className="card-body">
            <form onSubmit={login}>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nom d'utilisateur"
                  required
                  name="username"
                  value={values.username}
                  autoFocus
                  onChange={handleChange}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-envelope" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type={showPwd ? "text" : "password"}
                  className="form-control"
                  placeholder="Password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  required
                />
                <div className="input-group-append">
                  <div
                    className="input-group-text"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPwd((showPwd) => !showPwd)}
                  >
                    {showPwd ? iconEye : iconLock}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-8">
                  <div className="icheck-primary">
                    <input type="checkbox" id="remember" />
                    <label htmlFor="remember" style={{ marginLeft: "5px" }}>
                      Se souvenir de moi
                    </label>
                  </div>
                </div>
                {/* /.col */}
                <div className="col-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-block"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <Spin size="sm" />
                    ) : (
                      <MdLogin style={{ fontSize: "20px" }} />
                    )}
                  </button>
                </div>
                {/* /.col */}
              </div>
            </form>
          </div>
          {/* /.card-body */}
        </div>
        {/* /.card */}
      </div>
      {/* /.login-box */}
    </>
  );
};

export default Login;
